import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface Step {
    icon: string;
    title: string;
}

@Component
export default class EpicGuideProcessBar extends Vue {

    @Prop({ default: 'HOME SELLERS GUIDE' })
    public title!: string;

    @Prop({ default: 'Video, articles and tools to help you find your next home' })
    public subtitle!: string;

    @Prop({ default: function() {
        return [{
            title: 'Prepare for Selling',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/step-icon1.png',
            href: '#step1'
        }, {
            title: 'Listing Your House',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/step-icon2.png',
            href: '#step2'
        }, {
            title: 'Marketing Your Home',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/step-icon3.png',
            href: '#step3'
        }, {
            title: 'Make The Deal',
            icon: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-seller-guide/step-icon4.png',
            href: '#step4'
        }];
    } })
    public steps!: Step[];

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
